

















































































































import { SfLink, SfImage } from '~/components';
import { defineComponent, ref, watch, onMounted, onBeforeUnmount, computed, useContext } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import type { CategoryTree } from '~/modules/GraphQL/types';
import {useActiveCategory, useUiState} from "~/composables";
import { ensureTrailingSlash } from '~/helpers/ensureTrailingSlash';
import { formatAbsoluteUrlToLocal } from '~/utilities/helpers';

export default defineComponent({
  name: 'HeaderNavigationSubcategories',
  components: {
    SfLink,
    SfImage,
  },
  props: {
    currentCategory: {
      type: Object as PropType<CategoryTree | null>,
      default: () => null,
    },
  },
  setup(props, { emit }) {
    const { $config, localePath } = useContext();
    const currentImageDesktop = ref<string>(props.currentCategory?.image_desktop_url || '');

    const getCategoryLink = (url: string) => decodeURIComponent(
      localePath(formatAbsoluteUrlToLocal(url, $config))
    );

    const {
      toggleDesktopMenu,
      toggleMobileMenu,
      isDesktopMenuOpen,
      isMobileMenuOpen,
    } = useUiState();
    const navigationMediaQuery = process.client
      ? window.matchMedia('(max-width: 1023px)')
      : null;

    const isGiftCategory = computed(() => {
      if(props?.currentCategory) {
        return props?.currentCategory.label === 'Подарочные карты'
      }
    })

    const { searchActiveMenuElement } = useActiveCategory()

    const safeChildren = computed(() => {
      return props.currentCategory && props.currentCategory.children
        ? props.currentCategory.children
        : [];
    });

    const navigationSwitcher = (event) => {
        if (document) {
          const desktopMenu = document.querySelector('.sf-header__navigation');

          if (desktopMenu && event.matches && isDesktopMenuOpen.value) {
              toggleDesktopMenu();
              if (!isMobileMenuOpen.value) {
                toggleMobileMenu();
              }
          }
        }
    }

    const goToGiftCard = () => {
      localStorage.setItem('lastClickedLink', JSON.stringify({ url:"/podarochnye-karty", label:"Подарочные карты" }));

      emit('hideNavigation')
    }

    onMounted(() => {
      if (!navigationMediaQuery) return;

      navigationMediaQuery.addEventListener('change', navigationSwitcher);
      navigationSwitcher(navigationMediaQuery);
    })

    onBeforeUnmount(() => {
      if (!navigationMediaQuery) return;

      navigationMediaQuery.removeEventListener('change', navigationSwitcher);
    })

    watch(
      () => props.currentCategory,
      () => currentImageDesktop.value = props.currentCategory?.image_desktop_url,
      { immediate: true, deep: true }
    );

    const setImage = (imageDesktopUrl) => {
      if (imageDesktopUrl) currentImageDesktop.value = imageDesktopUrl;
    };

    const resetImage = () => currentImageDesktop.value = props.currentCategory.image_desktop_url;

    return {
      currentImageDesktop,
      setImage,
      resetImage,
      safeChildren,
      isGiftCategory,
      toggleDesktopMenu,
      goToGiftCard,
      searchActiveMenuElement,
      getCategoryLink,
    };
  },
  methods: {
    handleLinkClick(category) {
      let url = category.url_type === 'external'
        ? category.url
        : ensureTrailingSlash(this.getCategoryLink(category.url));
      let label = category.label;

      const linkData = {
        url: url,
        label: label,
      };

      localStorage.setItem('lastClickedLink', JSON.stringify(linkData));

      this.$emit('hideNavigation');
    }
  }
});
